var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlaTimerStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.75C12.09 13.75 11.75 13.41 11.75 13V8C11.75 7.59 12.09 7.25 12.5 7.25C12.91 7.25 13.25 7.59 13.25 8V13C13.25 13.41 12.91 13.75 12.5 13.75Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.75C7.26 22.75 3 18.49 3 13.25C3 8.01 7.26 3.75 12.5 3.75C17.74 3.75 22 8.01 22 13.25C22 13.66 21.66 14 21.25 14C20.84 14 20.5 13.66 20.5 13.25C20.5 8.84 16.91 5.25 12.5 5.25C8.09 5.25 4.5 8.84 4.5 13.25C4.5 17.66 8.09 21.25 12.5 21.25C12.91 21.25 13.25 21.59 13.25 22C13.25 22.41 12.91 22.75 12.5 22.75Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.75H9.5C9.09 2.75 8.75 2.41 8.75 2C8.75 1.59 9.09 1.25 9.5 1.25H15.5C15.91 1.25 16.25 1.59 16.25 2C16.25 2.41 15.91 2.75 15.5 2.75Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 22.0198C16.3 22.0198 15.98 21.9398 15.69 21.7698C15.03 21.3898 14.65 20.6198 14.65 19.6598V17.3498C14.65 16.3898 15.03 15.6198 15.69 15.2398C16.35 14.8598 17.2 14.9198 18.03 15.3898L20.03 16.5498C20.86 17.0298 21.34 17.7398 21.34 18.4998C21.34 19.2598 20.86 19.9698 20.03 20.4498L18.03 21.6098C17.57 21.8798 17.1 22.0198 16.65 22.0198ZM16.66 16.4798C16.58 16.4798 16.5 16.4998 16.44 16.5298C16.26 16.6298 16.15 16.9398 16.15 17.3398V19.6498C16.15 20.0498 16.26 20.3598 16.44 20.4598C16.62 20.5598 16.94 20.5098 17.28 20.3098L19.28 19.1498C19.63 18.9498 19.84 18.6998 19.84 18.4998C19.84 18.2998 19.63 18.0498 19.28 17.8498L17.28 16.6898C17.05 16.5498 16.83 16.4798 16.66 16.4798Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlaTimerStart);
export default __webpack_public_path__ + "static/media/SLA-timerStart.51688f35.svg";
export { ForwardRef as ReactComponent };